/**
 * Static route segments. Used by the router and by the shell builder, which writes
 * a studio-specific index.html into each of these directories so that deep links
 * receive the right studio shell (title, manifest, icons) on any static host.
 */
export const CLIENT_ROUTE_SEGMENTS = ['', 'services', 'my', 'assistant', 'app'] as const;
export const OWNER_ROUTE_SEGMENTS = ['', 'login', 'bookings', 'new', 'settings', 'gallery', 'assistant'] as const;

export const studioBase = (slug: string) => `/s/${slug}/`;
export const ownerBase = (slug: string) => `/s/${slug}/owner/`;

export const SLUG_PATTERN = /^[a-z0-9](?:[a-z0-9-]{0,38}[a-z0-9])?$/;
